export default [
  { title: "Негабарит", subGroup: false, compactMode: false },
  { title: "Паллеты", subGroup: true, compactMode: true },
  { title: "Иное", subGroup: true, compactMode: true },
];